export default "__VITE_ASSET__4PlVoPtcCtPBpDBdewCL1Q__"